import React from 'react';
import { Store } from './stores/store';
import { audienceStore } from './stores/audienceStore';
import { MapStore } from './stores/mapstore';

export const Stores = {
  audience: new audienceStore(),
  store: new Store(),
  mapstore: new MapStore(),
};

export const StoreContext = React.createContext(Stores);
